import { api } from './axios'
import type { CurrentKeyResponseDto, GenerateKeyResponseDto } from './types'

// Get current API key metadata
export const getCurrentApiKey = async (): Promise<CurrentKeyResponseDto> => {
  const response = await api.get('/api-keys')

  return response.data
}

// Generate new API key (replaces any existing active key)
export const generateApiKey = async (): Promise<GenerateKeyResponseDto> => {
  const response = await api.post('/api-keys')

  return response.data
}

// Delete current API key
export const deleteCurrentApiKey = async (): Promise<void> => {
  await api.delete('/api-keys')
}
